import { GalleryImage } from "components/shared/Gallery/typings";

export const getFullScreenImages = (images: GalleryImage[]): GalleryImage[] => {
  return images.map((galleryItemImage: GalleryImage) => ({
    ...galleryItemImage,
    caption: galleryItemImage.attribRequired && galleryItemImage.alt ? galleryItemImage.alt : galleryItemImage.caption,
    src: galleryItemImage.originalMediaUrl || galleryItemImage.src,
  }));
};
